angular.module('app.atencion', [
  'ui.router',
  'toastr',
  'app.atencionService',
  'app.casosService'
])

  .config(
    ['$stateProvider', '$urlRouterProvider',
      function ($stateProvider, $urlRouterProvider) {
        $stateProvider
          .state('index.atencion', {

            abstract: true,

            url: 'atencion',

            params: {

            },

            views: {
              '': {
                templateUrl: 'app/atencion/atencion.tpl.html',
                resolve:
                  {

                  },
                controller: ['$scope', '$state', 'toastr',
                  function ($scope, $state, toastr) {



                  }]
              }
            }

          })
          .state('index.atencion.usuario', {

            url: '',

            views: {
              '': {
                templateUrl: 'app/atencion/atencion.usuario.tpl.html',
                resolve: {
                  dataDespacho: ['casosService',
                    function(casosService)
                    {
                    return casosService.getDespacho();
                    }]
                  },
                controller: ['$scope', '$state', 'atencionService', 'toastr', 'ngDialog', 'authService', 'dataDespacho', 'casosService',
                  function ($scope, $state, atencionService, toastr, ngDialog, authService, dataDespacho, casosService ) {
                           
                    CENTRO = authService.getLocalData('CENTRO');         
                    $scope.deshabilitar_centros = true;
                    $scope.mostrar_centros = false;

                    $scope.deshabilitar_opciones_atencion = false;
                    if ((CENTRO.ID_CARGO != $scope.CONSTANTES.CARGO_ASISTENTE) &&
                        (CENTRO.ID_CARGO != $scope.CONSTANTES.CARGO_MEDIADOR))
                    {
                      $scope.deshabilitar_opciones_atencion = true; 
                      $scope.mostrar_centros = true;
                      $scope.deshabilitar_centros = false;
                    }

                    getAtenciones = function(despacho,anio)
                    {
                      atencionService.getAtenciones(despacho,anio).then(
                        function ( response ) 
                        {
                          $scope.atenciones = [];
                          $scope.atenciones = response.data;
                        },
                        function ( error ) 
                        {
                            toastr.error( error );
                        });
                    }

                    //se obtienen los centros de mediacion
                    $scope.centros = [];
                    $scope.centros = dataDespacho.data;

                    //se selecciona el anio de los casos a desplegar en pantalla
                    $scope.selectedAnioCasos = function (item)
                    {
                      $scope.centros.ANIO = item.ANIO;
                      getAtenciones($scope.centros.ID_DESPACHO,$scope.centros.ANIO);
                    }
                    //se obtienen los mediadores segun centro
                    getAnioCasos = function(despacho,opcion)
                    {
                      casosService.getAnioCasos(despacho,opcion).then(
                        function ( response ) 
                        {
                          $scope.anioCasos = [];
                          $scope.anioCasos = response.data;
                          if ($scope.anioCasos.length > 0)
                          {
                            $scope.selectedAnioCasos(response.data[0]);
                          }
                        },
                        function ( error ) 
                        {
                            toastr.error( error );
                        }); 
                    }

                    $scope.selectedCentro = function (item)
                    {
                      $scope.centros.ID_DESPACHO = item.ID_DESPACHO;
                      $scope.centros.ANIO="";
                      $scope.atenciones = [];
                      getAnioCasos($scope.centros.ID_DESPACHO, $scope.CONSTANTES.ANIOS_ATENCION);
                    }
                    if ((CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_ASISTENTE) ||
                        (CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_MEDIADOR))
                    {
                      $scope.selectedCentro({ID_DESPACHO:CENTRO.ID_DESPACHO});
                    }

                    $scope.viewAtencion = function(edicion,item)
                    {
                      $scope.dialogShowAtencion = ngDialog.open(
                      {
                        template: 'app/atencion/atencion.gestionar.tpl.html',
                        resolve: {
                          dataTipoIdentificacion: ['casosService',
                            function (casosService) {
                              return casosService.getTipoIdentificacion($scope.CONSTANTES.TIPO_SUJETO_NATURAL);
                            }],
                          dataGenero: ['casosService',
                            function(casosService)
                            {
                            return casosService.getGenero();
                            }],
                          dataMediador: ['casosService',
                            function(casosService)
                            {
                            return casosService.getMediadoresCentro(CENTRO.ID_DESPACHO, $scope.loginData.ID_USUARIO, $scope.CONSTANTES.CARGO_ASISTENTE);
                            }],
                          dataIdioma: ['casosService',
                            function(casosService)
                            {
                            return casosService.getIdioma(0,0,$scope.CONSTANTES.TIPO_CLS_IDIOMA_SESION);
                            }],
                          dataTiempoAtencion: ['atencionService',
                            function(atencionService)
                            {
                            return atencionService.getTiempoAtencion();
                            }]
                          },
                        showClose: true,
                        closeByEscape: true,
                        closeByNavigation: true,
                        preCloseCallback:function()
                        {
                          if ($scope.centros.ANIO == "")
                          {
                            getAnioCasos($scope.centros.ID_DESPACHO, $scope.CONSTANTES.ANIOS_ATENCION);
                          }
                          if (($scope.atenciones.length > 0) && ($scope.centros.ANIO != ""))
                          {
                            getAtenciones($scope.centros.ID_DESPACHO,$scope.centros.ANIO);
                          }
                        },
                        className: 'ngdialog-theme-flat-custom',
                        scope:$scope,
                        controller: ['$scope', 'dataTipoIdentificacion', 'dataGenero', 'dataMediador', 'dataIdioma', 'dataTiempoAtencion', 
                        'casosService', 'atencionService',
                          function($scope, dataTipoIdentificacion, dataGenero, dataMediador, dataIdioma, dataTiempoAtencion, 
                            casosService, atencionService) 
                        {
                          //se inicializa el arreglo de los tipos de identificacion
                          $scope.tipoIdentificacion = [];
                          $scope.tipoIdentificacion = dataTipoIdentificacion.data;
                          
                          //se inicializa el arreglo del sexo del sujeto
                          $scope.generos = [];
                          $scope.generos = dataGenero.data;
                          
                          //se inicializa el arreglo de mediadores
                          $scope.mediadoresCentro = [];
                          $scope.mediadoresCentro = dataMediador.data;

                          //se inicializa el arreglo de tiempo de atencion
                          $scope.duracionAtencion = [];
                          $scope.duracionAtencion = dataTiempoAtencion.data;

                          //se inicializa el arreglo de idiomas
                          $scope.idiomasAtencion = [];
                          $scope.idiomasAtencion = dataIdioma.data;

                          $scope.UBICACION_CORRECTA = true;
                          $scope.deshabilitar_datos_atencion = false;
                          $scope.tiempo_focus="500";
                          $scope.atencion = {};
                          
                          $scope.cambiar_focus_identificacion = function()
                          {
                            $scope.focus_identificacion_atencion = false;
                            $scope.UBICACION_CORRECTA = false;
                            if ((($scope.atencion.IDENTIFICACION != undefined) && 
                                  ($scope.atencion.IDENTIFICACION != "")) || 
                                ($scope.atencion.ID_TIPO_IDENTIFICACION != $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI)) 
                            {
                              $scope.UBICACION_CORRECTA = true;
                            }
                          }
                          $scope.cambiar_focus_identificacion();

                          getUbicacionNacimiento = function(IDENTIFICACION)
                          {
                            IDENTIFICACION = IDENTIFICACION.replace(/\s/g, "");
                            IDENTIFICACION = IDENTIFICACION.substring(IDENTIFICACION.length-4, IDENTIFICACION.length);                      
                            casosService.getUbicacionNacimiento(IDENTIFICACION).then(
                              function ( response ) 
                              { 
                                if (response.data.id == 0)
                                {
                                  toastr.warning(response.data.msj);
                                  $scope.mensaje_ubicacion_incorrecta = response.data.msj
                                  $scope.UBICACION_CORRECTA = false;
                                }
                                else
                                {
                                  $scope.UBICACION_CORRECTA = true;
                                }
                              },
                              function ( error ) 
                              {
                                toastr.error( error );
                              });  
                          }

                          validaUbicacionNacimiento = function()
                          {
                            if (($scope.atencion.IDENTIFICACION != undefined) && 
                                      ($scope.atencion.IDENTIFICACION != "") &&
                                      ($scope.atencion.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI))
                              {
                                getUbicacionNacimiento($scope.atencion.IDENTIFICACION);
                              }
                          }

                          $scope.valida_identificacion = function(IDENTIFICACION)
                          {
                            if (IDENTIFICACION != undefined)
                            {
                              if (contador_mensajes_invalidos < 100) 
                              {
                                validaUbicacionNacimiento();
                              }
                              contador_mensajes_invalidos++;
                            }
                          }

                          $scope.reinicio_contado_mensajes_invalidos = function()
                          {
                            contador_mensajes_invalidos = 0;
                            // $scope.cambiar_focus_identificacion();
                          }
                          $scope.reinicio_contado_mensajes_invalidos();

                          $scope.valida_enfoque_identificacion = function()
                          {
                            if (($scope.atencion.IDENTIFICACION == undefined) || 
                                  ($scope.atencion.IDENTIFICACION == ""))
                            {
                              $scope.UBICACION_CORRECTA = true;
                            }
                          }

                          $scope.selectedTipoIdentificacion = function (item)
                          {
                            $scope.atencion.ID_TIPO_IDENTIFICACION = item.ID_TIPO_IDENTIFICACION;
                            $scope.atencion.MASCARA_IDENTIFICACION = item.MASCARA;
                            $scope.focus_identificacion_atencion = true;
                          }

                          $scope.verificar_longitud = function(longitud)
                          {  
                            $scope.LONGITUD_DESCRIPCION_ATENCION = false;
                            if (longitud >= $scope.CONSTANTES.LONGITUD_DESCRIPCION_ATENCION)
                            {
                              $scope.LONGITUD_DESCRIPCION_ATENCION = true;
                            }   
                          }

                          //funciones formulario sesion
                          fechaFormatoYYYYMMDD = function (date)
                          {
                            if (date != undefined)
                            {
                              d = new Date(date);
                              month = '' + (d.getMonth() + 1);
                              day = '' + d.getDate();
                              year = d.getFullYear();
                              if (month.length < 2) month = '0' + month;
                              if (day.length < 2) day = '0' + day;
                              return [year, month, day].join('-');
                            }
                            else
                            return "";
                          }

                          buscarMediadorCentro = function(valor, arreglo)
                          {
                            for (var i=0; i < arreglo.length; i++) 
                            {
                              if (arreglo[i].ID_MEDIADOR === valor) 
                              { 
                                return true;
                              }
                            }
                            return false;
                          }

                          $scope.guardarAtencion = function(isValid,genero,longitud_descripcion)
                          {
                            if ((isValid) && (genero != undefined) && (longitud_descripcion))
                            {
                              if (edicion)
                              {
                                atencionService.edtAtencion($scope.atencion).then(
                                  function (response)
                                  {
                                    if(response.data.result=='OK')
                                    {
                                      toastr.success(response.data.msj);
                                      // getAtenciones($scope.centros.ID_DESPACHO,$scope.centros.ANIO);
                                      $scope.atencion = {};
                                      ngDialog.closeAll();
                                    }
                                    else
                                    {
                                      toastr.error(response.data.msj);
                                    }                      
                                  },
                                  function (error) 
                                  {
                                    toastr.error( error );
                                  }); 
                              }
                              else
                              {
                                atencionService.insAtencion($scope.atencion).then(
                                  function (response)
                                  {
                                    if(response.data.result=='OK')
                                    {
                                      toastr.success(response.data.msj);
                                      // getAtenciones($scope.centros.ID_DESPACHO,$scope.centros.ANIO);
                                      $scope.atencion = {};
                                      ngDialog.closeAll();
                                    }
                                    else
                                    {
                                      toastr.error(response.data.msj);
                                    }                      
                                  },
                                  function (error) 
                                  {
                                    toastr.error( error );
                                  }); 
                              }
                            }
                            else
                            {
                              toastr.warning("Faltan datos por ingresar");
                            }
                          }
                    
                          $scope.descripcion_formulario_atencion = "Atención a usuario"

                          if (edicion)
                          {
                            $scope.tooltip_boton_guardar_atencion ="Guardar cambios";
                            $scope.atencion = item;
                            $scope.atencion.FECHA_REGISTRO = fechaFormatoYYYYMMDD($scope.atencion.FECHA_REGISTRO) + ' 00:00:00.0';
                            $scope.LONGITUD_DESCRIPCION_ATENCION = true;
                            if ($scope.atencion.ATENCION_EDITABLE == $scope.CONSTANTES.REGISTRO_FALSO)
                            {
                              $scope.deshabilitar_datos_atencion = true;
                            }
                             $scope.mostrar_combo_mediador = buscarMediadorCentro(item.ID_MEDIADOR,$scope.mediadoresCentro);
                             
                            // if ()
                            // {
                            //   $scope.mostrar_combo_mediador = false;
                            // }
                            // console.log('edicion',$scope.mostrar_combo_mediador);
                          }
                          else
                          {
                            $scope.tooltip_boton_guardar_atencion ="Guardar atención";
                            if ($scope.mediadoresCentro.length == 1)
                            {
                              $scope.atencion.ID_MEDIADOR = $scope.mediadoresCentro[0].ID_MEDIADOR;
                            }
                            $scope.atencion.FECHA_REGISTRO = fechaFormatoYYYYMMDD(new Date()) + ' 00:00:00.0';
                            $scope.atencion.ID_DESPACHO = CENTRO.ID_DESPACHO;
                            $scope.mostrar_combo_mediador = true;
                            
                          }

                        }] 
                      });  
                    }


                    // $scope.viewAtencion();
                     
                            
                  }]
              }
            }
          })
      }
    ]
  );